import {AxiosError} from "axios";
import {needAuth} from "../instance/Instance";

const selectHandlers = async (data) => {
    try {
        return await needAuth.get(`/handlers/${data.contentId}/${data.contentCategory}`)
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const saveHandlers = async (data) => {
    try {
        return await needAuth.post(`/handlers`, data);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const removeHandler = async (data) => {
    try {
        return await needAuth.put(`/handlers`, data);
    } catch(error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

export {selectHandlers, saveHandlers, removeHandler};